import React, { Component } from 'react';
import country from '../country';
import Menu from './Menu';

class Search extends Component {
	constructor(props) {
		super(props);
		this.state = {
			code: ''
		};
		this.getCountry = this.getCountry.bind(this);
		this.titleCase = this.titleCase.bind(this);
	}

	getCountry = async (e) => {
		var countryname = e.target.value;
		var flag = 0;
		countryname = this.titleCase(countryname);
		/* console.log(countryname) */
		await country.forEach((data) => {
			if (data.Name === countryname) {
				flag = 1;
				this.setState({
					code: data.Code
				});
			}
		});
		if (flag === 0) {
			this.setState({
				code: ''
			});
		}
	};

	titleCase(str) {
		var splitStr = str.toLowerCase().split(' ');
		for (var i = 0; i < splitStr.length; i++) {
			// You do not need to check if i is larger than splitStr length, as your for does that for you
			// Assign it back to the array
			splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
		}
		// Directly return the joined string
		return splitStr.join(' ');
	}

	render() {
		var menu = '';
		if (this.state.code) menu = <Menu code={this.state.code} />;
		return (
			<div>
				<div className='jumbotron'>
					<div className='container text-center'>
						<h1>Enter your country Name:</h1>
						<br />
						<input
							style={{ width: '70%', height: '35px' }}
							type='text'
							className='capitalize'
							name='country'
							ref='country'
							onChange={this.getCountry}
						/>
						<br />
					</div>
				</div>
				{menu}
			</div>
		);
	}
}

export default Search;
